export const SET_STATE = 'SET_STATE';
export const SET_ERROR_INVOICES = 'SET_ERROR_INVOICES';
export const UPDATE_APP_DIRECTORY = 'UPDATE_APP_DIRECTORY';
export const INVOICE_CHECK_ALL_CHANGED = 'INVOICE_CHECK_ALL_CHANGED';
export const INVOICE_CHECK_ITEM_CHANGED = 'INVOICE_CHECK_ITEM_CHANGED';
export const RESET_CHECK_INVOICE = 'RESET_CHECK_INVOICE';
export const GET_DETAILS_INVOICE = 'GET_DETAILS_INVOICE';
export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const GET_VENDORS = 'GET_GET_VENDORS';
export const SET_INVOICE_GLOBAL_SEARCH_PARAMS = 'SET_INVOICE_GLOBAL_SEARCH_PARAMS';
export const LOAD_MORE_CUSTOMERS = 'LOAD_MORE_CUSTOMERS';
export const LOAD_MORE_VENDORS = 'LOAD_MORE_VENDORS';
export const GET_IN_PROGRESS_INVOICES = 'GET_IN_PROGRESS_INVOICES';
export const APPROVE_LIST_INVOICE = 'APPROVE_LIST_INVOICE';
export const DETAILS_INVOICE_LOADING = 'DETAILS_INVOICE_LOADING';
export const CUSTOMER_LIST_LOADING = 'CUSTOMER_LIST_LOADING';
export const VENDOR_LIST_LOADING = 'VENDOR_LIST_LOADING';
export const SET_INVOICE_COUNT = 'SET_INVOICE_COUNT';
export const SET_PAID_DATE = 'SET_PAID_DATE';
export const CLONE_INVOICES = 'CLONE_INVOICES';
export const SET_IMPORTED_INVOICES = 'SET_IMPORTED_INVOICES';
export const GET_APP_STATISTIC = 'GET_APP_STATISTIC';
export const GET_CURRENT_STATISTIC = 'GET_CURRENT_STATISTIC';
export const SET_CURRENT_STATISTIC = 'SET_CURRENT_STATISTIC';
export const GET_INVOICES_STATISTIC = 'GET_INVOICES_STATISTIC';

// INVOICES
export const GET_INVOICES = 'GET_INVOICES';
export const GET_INVOICES_ISSUING = 'GET_INVOICES_ISSUING';
export const LOAD_MORE_INVOICES = 'LOAD_MORE_INVOICES';
export const INVOICE_LIST_PAGE_INFO = 'INVOICE_LIST_PAGE_INFO';
export const INVOICE_LIST_LOADING = 'INVOICE_LIST_LOADING';
export const FILTER_INVOICES = 'FILTER_INVOICES';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const UPDATE_INVOICE_FIELD = 'UPDATE_INVOICE_FIELD';
export const CREATE_INVOICE = 'CREATE_INVOICE';

// INVOICE FILE
export const INVOICE_FILE_CHANGED = 'INVOICE_FILE_CHANGED';
export const INVOICE_FILE_LOADING = 'INVOICE_FILE_LOADING';
export const DOWNLOAD_INVOICE_LOADING = 'DOWNLOAD_INVOICE_LOADING';
export const DOWNLOAD_EXCEL_LOADING = 'DOWNLOAD_EXCEL_LOADING';
export const DOWNLOAD_XML_BCSS_LOADING = 'DOWNLOAD_XML_BCSS_LOADING';

// SETTINGS
export const GET_SELLER_SETTING_LIST = 'GET_SELLER_SETTING_LIST';
export const GET_CACHED_SELLER_SETTING_LIST = 'GET_CACHED_SELLER_SETTING_LIST';

// ENUM
export const GET_INVOICE_LIST_ENUM = 'GET_INVOICE_LIST_ENUM';

// COMMON CODE
export const GET_INVOICE_COMMON_CODE = 'GET_INVOICE_COMMON_CODE';

// TAGS
export const SET_TAG = 'SET_TAG';
export const GET_TAGS = 'GET_TAGS';
export const DELETE_TAG = 'DELETE_TAG';
export const CREATE_TAG = 'CREATE_TAG';
export const UPDATE_TAG = 'UPDATE_TAG';

// ACTIVE ANNOUNCEMENT LINES
export const GET_ACTIVE_ANNOUNCEMENT_LINES = 'GET_ACTIVE_ANNOUNCEMENT_LINES';
export const GET_CACHED_ACTIVE_ANNOUNCEMENT_LINES = 'GET_CACHED_ACTIVE_ANNOUNCEMENT_LINES';

// NOTIFICATIONS
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_UNREAD_NOTIFICATIONS = 'GET_UNREAD_NOTIFICATIONS';
export const LOAD_MORE_NOTIFICATIONS = 'LOAD_MORE_NOTIFICATIONS';
export const LOAD_MORE_UNREAD_NOTIFICATIONS = 'LOAD_MORE_UNREAD_NOTIFICATIONS';
export const NOTIFICATIONS_LOADING = 'NOTIFICATIONS_LOADING';
export const MARK_READ_NOTIFICATION = 'MARK_READ_NOTIFICATION';

export default {
  SET_STATE,
  UPDATE_APP_DIRECTORY,
  INVOICE_CHECK_ALL_CHANGED,
  INVOICE_CHECK_ITEM_CHANGED,
  RESET_CHECK_INVOICE,
  GET_DETAILS_INVOICE,
  GET_CUSTOMERS,
  GET_VENDORS,
  SET_INVOICE_GLOBAL_SEARCH_PARAMS,
  LOAD_MORE_CUSTOMERS,
  LOAD_MORE_VENDORS,
  GET_IN_PROGRESS_INVOICES,
  APPROVE_LIST_INVOICE,
  SET_INVOICE_COUNT,
  DETAILS_INVOICE_LOADING,
  CUSTOMER_LIST_LOADING,
  VENDOR_LIST_LOADING,
  SET_PAID_DATE,
  CLONE_INVOICES,
  SET_IMPORTED_INVOICES,
  GET_APP_STATISTIC,
  GET_CURRENT_STATISTIC,
  SET_CURRENT_STATISTIC,
  GET_INVOICES_STATISTIC,

  // INVOICES
  GET_INVOICES,
  GET_INVOICES_ISSUING,
  LOAD_MORE_INVOICES,
  INVOICE_LIST_PAGE_INFO,
  INVOICE_LIST_LOADING,
  FILTER_INVOICES,
  UPDATE_INVOICE,
  UPDATE_INVOICE_FIELD,
  CREATE_INVOICE,

  // INVOICE FILE
  INVOICE_FILE_CHANGED,
  INVOICE_FILE_LOADING,
  DOWNLOAD_INVOICE_LOADING,
  DOWNLOAD_EXCEL_LOADING,
  DOWNLOAD_XML_BCSS_LOADING,

  // SETTINGS
  GET_SELLER_SETTING_LIST,
  GET_CACHED_SELLER_SETTING_LIST,

  // ENUM
  GET_INVOICE_LIST_ENUM,

  // COMMON CODE
  GET_INVOICE_COMMON_CODE,

  // TAGS
  GET_TAGS,
  DELETE_TAG,
  CREATE_TAG,
  UPDATE_TAG,
  SET_TAG,

  // ACTIVE ANNOUNCEMENT LINES
  GET_ACTIVE_ANNOUNCEMENT_LINES,
  GET_CACHED_ACTIVE_ANNOUNCEMENT_LINES,

  // NOTIFICATIONS
  GET_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS,
  LOAD_MORE_NOTIFICATIONS,
  LOAD_MORE_UNREAD_NOTIFICATIONS,
  NOTIFICATIONS_LOADING,
  MARK_READ_NOTIFICATION,
};



// WEBPACK FOOTER //
// ./src/store/mutation-types.js